import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Zap, Clock } from "lucide-react";
import { Layout } from "../components/Layout";
import { useI18n } from "../i18n";
import { eur } from "../lib/format";
import * as apiClient from "../api";

export default function LastMinute() {
  const { t } = useI18n();
  const { data: items = [], isLoading } = useQuery({ queryKey: ["lastminute"], queryFn: apiClient.getLastMinute });
  return (
    <Layout>
      <div className="bg-[#0A1128]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-accent mb-2 flex items-center gap-2"><Zap className="h-4 w-4" /> Last Minute</div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-semibold tracking-tight text-white">{t("home.lastminute")}</h1>
          <p className="text-white/50 mt-2">{t("home.lastminute.sub")}</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        {isLoading ? <div className="text-center py-20 text-slate-400">{t("common.loading")}</div> : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {items.map((e) => (
              <div key={e.id} data-testid={`lastminute-item-${e.id}`} className="bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm hover-lift">
                <div className="relative h-40 overflow-hidden">
                  <img src={e.image} alt={e.title} className="h-full w-full object-cover" loading="lazy" />
                  <span className="absolute top-3 right-3 rounded-full bg-accent text-white text-xs font-bold px-3 py-1 flex items-center gap-1"><Clock className="h-3 w-3" />{e.time}</span>
                </div>
                <div className="p-4">
                  <h3 className="font-heading font-semibold text-slate-900 line-clamp-1">{e.title}</h3>
                  <div className="text-xs text-accent font-semibold mt-1">{t("exp.few")}: {e.seats_left}</div>
                  <div className="mt-3 flex items-center gap-2">
                    <span className="text-slate-400 line-through text-sm">{eur(e.original_price)}</span>
                    <span className="text-xl font-heading font-bold text-primary">{eur(e.discount_price)}</span>
                    <span className="ml-auto rounded-full bg-emerald-50 text-emerald-600 text-[10px] font-bold px-2 py-0.5">-20%</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
